import React, { useEffect, useState } from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate } from "react-router";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import DateSelect from "../../../components/TimePicker/DateSelect";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { Button } from "semantic-ui-react";
import dayjs from "dayjs";
import { formatTime, getToday } from "../../../utils/getDay";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  UPLOAD_FILE,
  uploadFile,
} from "../../../redux/action/member/memberAction";
import AlreadyBind from "./alreadyBind";

const BindIdCard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const dispatch = useDispatch();
  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const [data, setData] = useState({
    id_card: localStorage.getItem("id_card") || "",
    birth: localStorage.getItem("birth") || getToday(),
  });
  const { id_card, birth } = data;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    localStorage.setItem(name, value);
  };

  useEffect(() => {
    if (!localStorage.getItem("step") && memberData.isBindAccount == 0) {
      localStorage.setItem("step", "1");
    }
  }, []);

  return memberData.isBindAccount == 1 ? (
    <AlreadyBind />
  ) : (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => {
              navigate("..");
              localStorage.clear();
            }}
          />
        }
        title={i18n("bindIdCard")}
      />
      <article className="flex flex-col gap-[15px] p-[15px] text-transaction-text dark:text-base-light-white font-medium">
        <span className="text-xl text-main-color">
          {i18n("idCard.inputIdInformation")}
        </span>
        <span className="text-main-color text-base">
          {i18n("idCard.hint.1")}
        </span>
        <span className="text-base text-sm">
          1. {i18n("idCard.hint.2")}
          <br />（ {i18n("idCard.hint.2-1")}）
        </span>
        <span className="text-base text-sm">
          2. {i18n("idCard.hint.3")} <br />（ {i18n("idCard.hint.3-1")}）
        </span>
        <div>
          <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
            {i18n("form.inputId")}
            <OriginInputCustom
              onChange={(e) => {
                handleChange(e);
              }}
              type="text"
              name="id_card"
              value={id_card}
              placeholder={i18n("form.inputId")}
            />
          </span>
        </div>
        <div className="custom-picker-field ">
          <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
            {i18n("form.inputBirthday")}(DD/MM/YYYY)
          </span>
          {/* <SemanticDatepicker
            className="w-full !bg-transaction-card dark:!bg-base-light-dark !text-black dark:!text-base-light-white  custom-picker"
            value={dayjs(birth).toDate()}
            onChange={(event, data) => {
              if (data.value) {
                setData({ ...data, birth: data.value });
                localStorage.setItem("birth", data.value);
              }
            }}
            type="year"
            clearable={false}
          /> */}
          <OriginInputCustom
            onChange={(e) => {
              handleChange(e);
            }}
            type="date"
            name="birth"
            value={birth}
            placeholder={i18n("form.inputId")}
          />
        </div>
        <Button
          disabled={!Object.keys(data).every((item) => data?.[item] !== "")}
          type="button"
          content={i18n_common("nextStep")}
          size="xl"
          className="!bg-main-color !text-white !py-[17px] !mt-[20px]"
          onClick={() => {
            localStorage.setItem("step", "2");
            navigate("../bind-bank-account");
          }}
        ></Button>
      </article>
    </DetailWrapper>
  );
};

export default BindIdCard;
